import { toast } from 'react-toastify';
import appApi from '../../../../../../../api/app-api';
import { displayErrorText } from '../../../../../../../api/errors/api-error-codes';

export const updatePermissionGroupPermissionsOperation = async (
  groupId: number,
  permissions: number[],
  setLoading: (loading: boolean) => void,
  onSuccess: () => void,
) => {
  try {
    setLoading(true);

    const res = await appApi.updatePermissionGroupPermissions(
      groupId,
      permissions,
    );

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      return;
    }

    toast.success('ההרשאות עודכנו בהצלחה');
    onSuccess();
  } catch (e) {
    console.error('updatePermissionGroupPermissionsOperation failed:', e);
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
  } finally {
    setLoading(false);
  }
};
